import { IRestrictedAccountObjectArgs, RestrictedAccountObject } from "../restricted-account-object/restricted-account-object.model";

export interface IContactArgs extends IRestrictedAccountObjectArgs {
    business?: string;
    name: string;
    email?: string;
    mobile?: string;
    phone?: string;
    fax?: string;
    website?: string;
    address?: string;
    address2?: string;
    address3?: string;
    contactType: string;
    vatNumber?: string;
    billingCode?: string;
}

const defaults = {
    business: "",
    name: "",
    email: "",
    mobile: "",
    phone: "",
    fax: "",
    website: "",
    address: "",
    address2: "",
    address3: "",
    contactType: "",
    vatNumber: "",
    billingCode: ""
} as IContactArgs;

export class Contact extends RestrictedAccountObject {
    business: string;
    name: string;
    email: string;
    mobile: string;
    phone: string;
    fax: string;
    website: string;
    address: string;
    address2: string;
    address3: string;
    contactType: string;
    vatNumber: string;
    billingCode?: string;

    constructor(data?: IContactArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.model.ts